import { useEffect, useState, useRef } from "react";
import { Scanner as QrReader } from "@yudiel/react-qr-scanner";
import request from "../../utilities/requests";
import { toast } from "../../utilities/SnackBarUtils";

const Scanner = () => {
  const [deviceId, setDeviceId] = useState(null);
  const [hasPermission, setHasPermission] = useState(null);
  const [lastScanned, setLastScanned] = useState({ value: null, timestamp: 0 });
  const [flash, setFlash] = useState(false);
  const [scannerKey, setScannerKey] = useState(0);
  const cooldownRef = useRef(false);
  const scannerRef = useRef(null);

  useEffect(() => {
    async function requestPermissionAndDetectDevice() {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
        setHasPermission(true);

        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );
        if (videoInputDevices.length > 0) {
          setDeviceId(videoInputDevices[0].deviceId);
        } else {
          setDeviceId(null);
        }
      } catch (err) {
        setHasPermission(false);
        console.error("Camera permission denied:", err);
      }
    }
    requestPermissionAndDetectDevice();
  }, []);

  const onDetected = async (val) => {
    const result = await request("ticketing/checkin", "post", { data: val });
    if (result.success) {
      toast.success(result.message);
      setFlash(true);
      setTimeout(() => setFlash(false), 300);
    }
  };

  if (hasPermission === false) {
    return (
      <div>
        Camera permission denied. Please allow camera access to use the scanner.
      </div>
    );
  }

  if (hasPermission === true && !deviceId) {
    return (
      <div>No camera device found. Please connect a camera and try again.</div>
    );
  }

  if (hasPermission === null) {
    return <div>Requesting camera permission...</div>;
  }

  return (
    <div>
      <div style={{ border: flash ? "4px solid #4caf50" : "4px solid transparent", borderRadius: "8px", transition: "border-color 0.3s ease" }}>
        <QrReader
          key={scannerKey}
          ref={scannerRef}
          deviceId={deviceId}
          onScan={async (detectedCodes) => {
            if (detectedCodes.length > 0 && !cooldownRef.current) {
              const newValue = detectedCodes[0].rawValue;
              const now = Date.now();
              if (
                newValue !== lastScanned.value ||
                now - lastScanned.timestamp > 2000
              ) {
                cooldownRef.current = true;
                if (scannerRef.current && scannerRef.current.pause) {
                  scannerRef.current.pause();
                }
                await onDetected(newValue);
                setLastScanned({ value: newValue, timestamp: now });
                if (scannerRef.current && scannerRef.current.resume) {
                  scannerRef.current.resume();
                }
                setTimeout(() => {
                  cooldownRef.current = false;
                }, 1500);
              }
            }
          }}
          onError={(err) => console.error("Scan error:", err)}
          formats={["qr_code"]}
          sound={true}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
        <button
          style={{ padding: "10px 20px", cursor: "pointer" }}
          onClick={() => setScannerKey((prev) => prev + 1)}
        >
          Reset Scanner
        </button>
      </div>
    </div>
  );
};

export default Scanner;
